const fundRequest = `{ 
    "Amount":125,
    "BackOfficeAccountNumber":"1GDN-GDN-000004-M",
    "RequestTypeId":1,
    "TransactionTypeId":2,
    "Requestee":"John Doe"
}`;

const getAccessToExternalAPI = `{	
  "Id": 8,	
  "FirstName": "John ",	
  "LastName": "Doe",	
  "Account": "123456",	
  "BackOfficeAccountNumber": "1GDN-GDN-000004-M",	
  "AccountName": "CITIZEN BANK",	
  "ABA": "AB090078601",	
  "AccountInfo": null,	
  "AccountTypeId": 1,	
   "IsDefault": true,	
  "Action": "Create",	
  "Address":"14th Street North Bay",	
  "CountryId":233,	
  "StateId":1452,	
  "Apt" : "H-No 789",	
  "City":"Bayharbour",	
  "ZipCode":"10253",	
  "Requestee":"John Doe",	
  "BankDetailsMisMatch": "false",	
  "RequestTypeId":1,	
  "TransactionTypeId":2,	
   "Amount":"49,999.99"	
 }`;

const post_journal_entry_request = `{
  "backofficeAccountNumber": "AAAA-AAA-980734-C",
  "transactionType": "Deposit",
  "amount": 0.01,
  "externalId": "string",
  "tradeDate": "2025-05-15T06:29:46.495Z"
}`;

const post_journal_entry_batch_request = `[
  {
    "backofficeAccountNumber": "AAAA-AAA-988425-C",
    "transactionType": "Deposit",
    "amount": 0.01,
    "externalId": "string",
    "tradeDate": "2025-05-15T06:32:03.675Z"
  },
  {
    "backofficeAccountNumber": "AAAA-AAA-988425-PX",
    "transactionType": "Withdrawal",
    "amount": 0.01,
    "externalId": "string",
    "tradeDate": "2025-05-15T06:32:03.675Z"
  }
]`;

export default {
  funding: {
    fundRequest,
    getAccessToExternalAPI,
  },
  journal: {
    post_journal_entry_request,
    post_journal_entry_batch_request,
  },
};
